import { useClientTranslation } from '@bts-web/utils-lokalise';
import { FC, PropsWithChildren } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { Divider } from '../../../../common';

const AssetListSection: FC<PropsWithChildren<{ title: string }>> = ({
  title,
  children,
}) => {
  const { t } = useClientTranslation();

  return (
    <section>
      <div
        className={css({
          color: 'neutrals.text_secondary',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 'extra_small_2',
          fontSize: '11px',
        })}
      >
        <h3
          className={css({
            fontSize: 'inherit',
          })}
        >
          {title}
        </h3>
        <span
          className={css({
            fontSize: 'inherit',
          })}
        >
          {t('estimated_yearly_rewards_@tenant' as 'estimated_yearly_rewards')}
        </span>
      </div>
      <Divider className={css({ marginInline: '-24px' })} />
      <ul>{children}</ul>
    </section>
  );
};

export { AssetListSection };
